import { FaPhotoVideo, FaRegClipboard, FaUserFriends } from "react-icons/fa";
import { FaCalendar } from "react-icons/fa6";
import { MdGroups } from "react-icons/md";


export const EmptyPostList = () => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <FaRegClipboard className="text-6xl mb-4" />
            <p className="text-lg font-semibold">No Posts Yet</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                It looks like you haven't created any posts yet. Start sharing your thoughts and updates!
            </p>
        </div>
    );
};


export const EmptyUserList = ({userType, description, actionButton}) => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <FaUserFriends className="text-6xl mb-4" />
            <p className="text-lg font-semibold">No {userType} Yet</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                {description}
            </p>
            {actionButton}
        </div>
    );
};


export const EmptyFriendList = () => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <FaUserFriends className="text-6xl mb-4" />
            <p className="text-lg font-semibold">No Pals Yet</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                It looks like you haven't added any pals yet. Connect with people to see them here!
            </p>
        </div>
    );
};

export const EmptyAlbumList = () => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <FaPhotoVideo className="text-6xl mb-4 text-gray-400" />
            <p className="text-lg font-semibold">No Albums Available</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                You haven't created any albums yet. Start by adding your favorite photos and videos!
            </p>
        </div>
    );
};


export const EmptyEventList = ({message, title}) => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <FaCalendar className="text-6xl mb-4 text-gray-400" />
            <p className="text-lg font-semibold">{title}</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                {message}
            </p>
        </div>
    );
};


export const EmptyGroupList = () => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <MdGroups className="text-6xl mb-4 text-gray-400" />
            <p className="text-lg font-semibold">No groups available</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                You haven't created any Groups yet!
            </p>
        </div>
    );
};


export const EmptyBookList = ({description}) => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <FaRegClipboard className="text-6xl mb-4" />
            <p className="text-lg font-semibold">No Books Available</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                {description}
            </p>
        </div>
    )
}


export const EmptyStoryCategory = ({ categoryName }) => {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-white">
            <FaRegClipboard className="text-6xl mb-4 text-gray-400" />
            <p className="text-lg font-semibold">No Stories Found</p>
            <p className="text-sm text-center max-w-xs mt-2 text-gray-500">
                It looks like there are no stories in the "{categoryName}" category yet. Check back later for new content!
            </p>
        </div>
    );
};